module.exports = __webpack_public_path__ + "static/img/price_banner.fa35485.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/uupay/images/price_banner.png
// module id = 8to8
// module chunks = 8